import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import VariableSelector from './variableSelector';

import { MODE } from '../utils/mode';

const CombineSelector = ({
  isVariable,
  mode,
  optionsList,
  secondOptionsKeyName,
  onFirstChange,
  onSecondChange,
  xs,
  sm,
  md,
  ...properties
}) => {
  const [secondOptions, setSecondOptions] = useState([]);
  const [selectedFirstValue, setSelectedFirstValue] = useState('');
  const [selectedSecondValue, setSelectedSecondValue] = useState('');

  useEffect(() => {
    if (selectedFirstValue) {
      const selectedFirst =
        optionsList && optionsList.options
          ? optionsList.options.find(
              (option) => option.value === selectedFirstValue
            )
          : undefined;

      setSecondOptions(
        selectedFirst ? selectedFirst[secondOptionsKeyName] || [] : []
      );
      // 防止無窮迴圈
    } else if (optionsList.firstValue) {
      setSelectedFirstValue(optionsList.firstValue);
    }
  }, [selectedFirstValue, optionsList, secondOptionsKeyName]);

  useEffect(() => {
    if (onFirstChange) {
      onFirstChange(selectedFirstValue);
    }
  }, [selectedFirstValue, onFirstChange]);

  useEffect(() => {
    if (secondOptions && !selectedSecondValue && optionsList.secondValue) {
      setSelectedSecondValue(optionsList.secondValue);
    }
  }, [secondOptions, selectedSecondValue, optionsList]);

  useEffect(() => {
    if (onSecondChange) {
      onSecondChange(selectedSecondValue);
    }
  }, [selectedSecondValue, onSecondChange]);

  return (
    <>
      <Grid item xs={xs} sm={sm} md={md}>
        <VariableSelector
          isVariable={isVariable}
          mode={mode}
          name={optionsList.firstName}
          label={optionsList.firstLabel}
          options={optionsList.options}
          onChange={(event) => setSelectedFirstValue(event.target.value)}
          value={selectedFirstValue}
          text={optionsList.firstText || optionsList.firstValue}
          {...properties}
        />
      </Grid>
      <Grid item xs={xs} sm={sm} md={md}>
        <VariableSelector
          isVariable={isVariable}
          mode={mode}
          name={optionsList.secondName}
          label={optionsList.secondLabel}
          options={
            secondOptions && secondOptions.length > 0 ? secondOptions : []
          }
          onChange={(event) => {
            setSelectedSecondValue(event.target.value);
          }}
          value={selectedSecondValue}
          text={optionsList.secondText || optionsList.secondValue}
          {...properties}
        />
      </Grid>
    </>
  );
};

CombineSelector.propTypes = {
  isVariable: PropTypes.bool,
  mode: PropTypes.string,
  optionsList: PropTypes.object,
  secondOptionsKeyName: PropTypes.string,
  onFirstChange: PropTypes.func,
  onSecondChange: PropTypes.func,
  xs: PropTypes.number,
  sm: PropTypes.number,
  md: PropTypes.number,
};

CombineSelector.defaultProps = {
  isVariable: true,
  mode: MODE.VIEW,
  optionsList: {
    firstName: 'city',
    firstLabel: '縣市',
    options: [],
    secondName: 'district',
    secondLabel: '區域',
  },
  onFirstChange: () => {},
  onSecondChange: () => {},
  xs: 6,
  sm: 3,
};

export default CombineSelector;
